<template>
    <div>
        <div class="mb-4" v-for="item in menu" :key="item.routeName">
            <Link class="group flex items-center py-3" :href="$route(item.routeName)">
                <div :class="isUrl(item.routeName) ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    {{ item.name }}
                </div>
            </Link>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import {adminMenu} from "@/Constants/menu"


export default {
    components: {
        Icon,
        Link
    },
    computed: {
        menu() {
            return adminMenu;
        }
    },
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
    },
}
</script>
